<template>
  <Menu as="div" class="relative inline-block text-left">
    <div>
      <MenuButton
        class="inline-flex w-full justify-center rounded-sm border border-gray-300 bg-white text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-100 p-2 pl-2.5 focus:ring-0 focus:outline-0 focus:ring-offset-0 disabled:opacity-50"
        :disabled="props.disabled"
      >
        <layers-two-one class="-ml-1 mr-2 h-4 w-4 text-gray-500" />
        {{ t("admin.search.filters.category") }}
        <chevron-down class="-mr-1 ml-2 h-4 w-4" aria-hidden="true" />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-sm bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none max-h-56 overflow-auto"
      >
        <div class="py-1">
          <MenuItem
            v-for="category in categories"
            :key="category.label"
            v-slot="{ active }"
          >
            <a
              href="#"
              :class="[
                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                'block px-4 py-2 text-sm',
              ]"
              @click="click(category.value)"
            >
              {{ category.label }}
            </a>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import ChevronDown from "@/Tailwind/Icon/ChevronDown";

import { computed, defineEmits, defineProps } from "vue";
import { useCategories } from "@/Tailwind/Mixins/useCategories";
import LayersTwoOne from "@/Tailwind/Icon/LayersTwoOne";

import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps({
  label: String,
  icon: HTMLElement,
  disabled: { type: Boolean, default: false },
  tenants: Array,
});

const categories = computed(() => useCategories(props.tenants));

const emit = defineEmits(["click"]);
const click = (categoryIds) => emit("click", categoryIds);
</script>

<style scoped></style>
